import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
  AIMS,
  ALBUMS,
  SHOWCASES,
  SIM_SEARCH,
} from '@disco/constants/FeatureTypes'
import { focusOnExplorer } from '@disco/state-management/actions/AppActions'
import * as ExplorerActions from '@disco/state-management/actions/ExplorerActions'
import { updateUserSettingsUnsafe } from '@disco/state-management/actions/ExplorerActions'
import * as SearchActions from '@disco/state-management/actions/SearchActions'
import * as SelectionActions from '@disco/state-management/actions/SelectionActions'
import { isFeatureEnabled } from '@disco/state-management/selectors/business'
import { getExplorerFirstPane } from '@disco/state-management/selectors/explorer'
import {
  getBaseSearchGroups,
  getSearchGroups,
  getSearchGroupsIndexed,
} from '@disco/state-management/selectors/groups'
import { getSearch } from '@disco/state-management/selectors/search'
import {
  getChosenSearchColumns,
  getUserSettings,
  isNativeTagsEnabled,
} from '@disco/state-management/selectors/user'

import { RootState } from 'store/configureStore'

const actions = {
  ...SearchActions,
  ...SelectionActions,
  ...ExplorerActions,
  updateUserSettingsUnsafe,
  focusOnExplorer,
}

class SearchWrapper extends React.Component<any> {
  render() {
    const { dispatch, children, search, ...rest } = this.props
    return React.cloneElement(children, {
      ...search,
      ...rest,
      ...bindActionCreators(actions, dispatch),
    })
  }
}

export default connect((state: RootState) => ({
  search: getSearch(state),
  playlists: state.playlists,
  tracks: state.tracks,
  baseSearchGroups: getBaseSearchGroups(state),
  searchGroups: getSearchGroups(state),
  searchGroupsIndexed: getSearchGroupsIndexed(state),
  sidebarOpen: state.app.sidebarOpen,
  windowWidth: state.app.windowWidth,
  mobileDeviceType: state.app.mobileDeviceType,
  explorerFirstPane: getExplorerFirstPane(state),
  chosenColumns: getChosenSearchColumns(state),
  nativeTagsEnabled: isNativeTagsEnabled(state),
  albumsEnabled: isFeatureEnabled(state, {
    featureName: ALBUMS,
  }),
  showcasesEnabled: isFeatureEnabled(state, {
    featureName: SHOWCASES,
  }),
  simSearchEnabled: isFeatureEnabled(state, {
    featureName: SIM_SEARCH,
  }),
  aimsEnabled: isFeatureEnabled(state, {
    featureName: AIMS,
  }),
  settings: getUserSettings(state),
  user: state.user,
  app: state.app,
}))(SearchWrapper)
